import React from "react";
import { Link } from "react-router-dom";

import Grid from "components/Grid";
import Loading from "components/Loading";
import Panel from "components/Panel";
import { useRoutes } from "utils/routes";

import {
  ServerGroupDashboardDatabaseTableQuery,
  useServerGroupDashboardDatabaseTableQuery,
} from "./gql/Query.generated";

type ServerGroupDatabase =
  ServerGroupDashboardDatabaseTableQuery["getServerGroupDatabases"][number];

type DatabaseRowDataType = {
  name: string;
  id: string;
  serverName: string;
  serverId: string;
};

const DatabaseTable = ({
  clusterId,
  organizationSlug,
}: {
  clusterId: string;
  organizationSlug: string;
}) => {
  const { data, loading, error } = useServerGroupDashboardDatabaseTableQuery({
    variables: {
      clusterId,
      organizationSlug,
    },
  });
  if (loading || error) {
    <Loading error={!!error} />;
  }
  const databases = data?.getServerGroupDatabases ?? [];
  return <TableContent data={databases} />;
};

const TableContent = ({ data }: { data: ServerGroupDatabase[] }) => {
  const databases: DatabaseRowDataType[] = data.map(
    (database: ServerGroupDatabase) => {
      return {
        name: database.datname,
        id: database.id,
        serverId: database.server.humanId,
        serverName: database.server.name,
      };
    },
  );

  return (
    <Panel title="All Databases">
      <Grid
        striped
        data={databases}
        defaultSortBy="name"
        columns={[
          {
            field: "name",
            header: "Database",
            width: "minmax(30%,1fr)",
            renderer: function DatabaseCell({
              rowData,
            }: {
              rowData: DatabaseRowDataType;
            }) {
              const { database } = useRoutes();
              return <Link to={database(rowData.id)}>{rowData.name}</Link>;
            },
          },
          {
            field: "serverName",
            header: "Server",
            width: "240px",
            renderer: function ServerCell({
              rowData,
            }: {
              rowData: DatabaseRowDataType;
            }) {
              const { server } = useRoutes();
              return (
                <Link to={server(rowData.serverId)}>{rowData.serverName}</Link>
              );
            },
          },
        ]}
      />
    </Panel>
  );
};
export default DatabaseTable;
